import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import { FreeMode } from 'swiper/modules';

const User = () => {
  return (
    <div id="main-wrapper">
      <Header />

      <div id="content" role="main">
        {/* Hero Section */}
        <section
          className="hero-wrap"
          style={{
            position: 'relative',
            overflow: 'hidden',
            minHeight: '60vh',
            display: 'flex',
            alignItems: 'center',
            backgroundImage: "url('/images/projects/audit.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="container" style={{ position: 'relative', zIndex: 2, paddingTop: '70px' }}>
            <div className="row">
              <div className="col-12 text-center text-white">
                <h1 className="text-16 font-weight-600 mb-3 text-white">User Identification</h1>
                <p className="lead text-white-100 mb-0">
                 Secure, Smart, and Seamless Identity Management
                </p>
              </div>
            </div>
          </div>
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', zIndex: 1 }}></div>
        </section>

        {/* Blog Intro */}
        <section className="py-5 bg-white text-dark">
          <div className="container">
            <div className="row align-items-center mb-5 g-4 flex-column-reverse flex-md-row"> 
              <div className="col-md-6 mb-4 mb-md-0"> 
                <img 
                  src="/images/projects/user2.png" 
                  alt="Robots on Factory Floor" 
                  className="img-fluid rounded-4 shadow-lg"
                  style={{ height: '350px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6">
                <h2 className="fw-bold mb-3">User Identification: Know Who’s Who Instantly</h2>
                <p className="text-black" style={{ fontSize: "1rem" }}>
                User Identification systems enable organizations to accurately recognize and verify individuals accessing facilities, applications, or services. By combining biometric, digital, and smart authentication methods, these systems provide secure, fast, and reliable verification while minimizing errors and enhancing operational efficiency.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* What is RovoConnect */}
        <section className="py-5 bg-light text-dark">
          <div className="container">
            <div className="row mb-4">
              <div className="col-lg-10 mx-auto text-center">
                <h2 className="fw-bold mb-3">What is User Identification?</h2>
                <p className="text-black" style={{ fontSize: "1rem" }}>
                  User Identification is the process of verifying the identity of individuals through unique identifiers such as fingerprints, facial recognition, ID cards, or digital credentials. It ensures that only authorized personnel can access specific systems, areas, or resources, improving security and accountability.
                </p>
              </div>
            </div>

            <div className="row g-4">
              {[
                { title: "Biometric Recognition", text: "Uses fingerprints, facial, or iris scans for precise identification.", icon: "bi bi-display", img: "/images/projects/bio.png" },
                { title: "Digital Credentials", text: "Supports RFID, QR codes, or mobile-based authentication.", icon: "bi bi-activity", img: "/images/projects/digia.png" },
                { title: "Access Control", text: "Grants or restricts entry based on verified identity.", icon: "bi bi-robot", img: "/images/projects/accs.png" },
                { title: "Audit Trail", text: "Maintains logs of every access attempt for accountability and reporting.", icon: "bi bi-clock", img: "/images/projects/audit.png" },
              ].map((feature, idx) => (
                <div className="col-12 col-md-6 col-lg-6 mb-4" key={idx}>
                  <div className="card h-100 border-0 shadow-lg rounded-4 overflow-hidden">
                    <img 
                      src={feature.img} 
                      alt={feature.title} 
                      className="card-img-top"
                      style={{ height: '250px', objectFit: 'cover', width: '100%' }} 
                    />
                    <div className="card-body">
                      <div className="mb-2 text-primary">
                        <i className={`${feature.icon} fs-2`}></i>
                      </div>
                      <h5 className="fw-bold mb-3">{feature.title}</h5>
                      <p className="text-muted mb-0">{feature.text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Business Impact */}
        <section className="py-5 bg-light text-dark">
          <div className="container">
            <div className="row align-items-center g-4 flex-column-reverse flex-md-row">
              <div className="col-md-6">
                <h2 className="fw-bold mb-4">Business Impact</h2>
                <p className="text-black" style={{ fontSize: "1rem" }}>User Identification strengthens organizational security and reduces risks of unauthorized access. It improves operational efficiency by streamlining access management, lowers compliance and audit risks, and ensures accountability. Businesses can prevent fraud, track employee or visitor activity, and enhance trust in their security ecosystem. Tracking and improving Overall Equipment Effectiveness (OEE) helps manufacturers maximize productivity, reduce costs, and make data-driven decisions.
                </p>
                {/* <ul className="list-unstyled text-muted fs-20">
                  <li className="mb-2"> Reduce unplanned downtime and maintenance costs</li>
                  <li className="mb-2"> Improve machine performance and utilization</li>
                  <li className="mb-2"> Enhance product quality and minimize defects</li>
                  <li className="mb-2"> Optimize production throughput and energy efficiency</li>
                  <li className="mb-2"> Support informed, data-driven operational decisions</li>
                </ul> */}
              </div>

              <div className="col-md-6">
                <img
                  src="/images/projects/bus1.png"
                  alt="Business Impact"
                  className="img-fluid rounded-4 shadow-lg"
                  style={{ height: '400px', objectFit: 'cover', width: '100%' }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Key Features & Capabilities */}
        <section className="py-5 bg-white text-dark">
          <div className="container">
            <div className="row mb-4">
              <div className="col-lg-10 mx-auto text-center">
                <h2 className="fw-bold mb-3">Key Features & Capabilities</h2>
                <p className="text-muted mb-5">
               Advanced Features to Ensure Secure and Efficient Access.
                </p>
              </div>
            </div>

            {/* Horizontal scrollable container */}
            <div
              className="d-flex flex-row flex-nowrap"
              style={{
                gap: "1rem",
                paddingBottom: "1rem",
                overflowX: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
              onWheel={(e) => {
                e.currentTarget.scrollLeft += e.deltaY;
              }}
            >
              <style>
                {`
                  div::-webkit-scrollbar {
                    display: none;
                  }
                  @media (max-width: 768px) {
                    .card {
                      min-width: 250px !important;
                      height: auto !important;
                    }
                    .card img {
                      height: 180px !important;
                    }
                  }
                `}
              </style>

              {[
                { title: "Fast and Accurate Verification", text: "Rapidly confirms identities with minimal errors.", icon: "bi bi-collection", img: "/images/projects/fast1.png" },
                { title: "Multi-Mode Authentication", text: "Supports biometrics, ID cards, mobile apps, and PINs.", icon: "bi bi-speedometer2", img: "/images/projects/mode.png" },
                { title: "Real-Time Alerts", text: "Notifies administrators of unauthorized or suspicious access attempts.", icon: "bi bi-bar-chart", img: "/images/projects/rtaa.png" },
                { title: "Seamless Integration", text: "Works with security systems, HR databases, and enterprise applications", icon: "bi bi-controller", img: "/images/projects/sem.png" },
                // { title: "Protocol Agnostic", text: "Supports TCP/IP, Modbus, EtherNet/IP, and more.", icon: "bi bi-layers", img: "/images/projects/rovovision.png" },
                // { title: "Decision-Making", text: "Make smarter decisions using real-time insights from robots and PLCs.", icon: "bi bi-layers", img: "/images/projects/rovovision.png" },
              ].map((feature, idx) => (
                <div
                  key={idx}
                  className="card flex-shrink-0 border-0 shadow-lg rounded-4 overflow-hidden"
                  style={{ width: "300px" }}
                >
                  <img
                    src={feature.img}
                    alt={feature.title}
                    className="card-img-top"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <div className="card-body">
                    <div className="mb-2 text-primary">
                      <i className={`${feature.icon} fs-2`}></i>
                    </div>
                    <h5 className="fw-bold mb-2">{feature.title}</h5>
                    <p className="text-muted mb-0">{feature.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Choose RovoConnect */}
        <section className="py-5 bg-light text-dark">
          <div className="container">
            <div className="row align-items-center g-4 flex-column-reverse flex-md-row">
              <div className="col-md-6">
                <img
                  src="/images/projects/why8.png"
                  alt="Why Choose RovoConnect"
                  className="img-fluid rounded-4 shadow-lg mb-4"
                  style={{ height: '400px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6">
                <h2 className="fw-bold mb-4">Why Choose User Identification?</h2>
                <p className="text-muted mb-4">
                  User Identification keeps your organization secure and efficient. It ensures only authorized people access your systems, provides real-time alerts, and tracks activity for accountability. Quick, reliable, and easy to use, it protects assets and streamlines operations.
                </p>
                <ul className="list-unstyled text-muted fs-6">
                  <li className="mb-3"><strong>Enhanced Security:</strong> Track machine performance, uptime, and productivity in real timePrevent unauthorized access and potential breaches.</li>
                  <li className="mb-3"><strong>Operational Efficiency:</strong> Streamline access for employees, visitors, and contractors.</li>
                  <li className="mb-3"><strong>Accountability:</strong>Maintain detailed logs of all entry and exit activities.</li>
                  <li className="mb-3"><strong>Regulatory Compliance:</strong> Meet security and privacy standards with robust identity tracking.</li>
                  
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Conclusion & CTA */}
        <section className="py-5 bg-dark text-white text-center">
          <div className="container">
            <p className="lead mb-4 mx-auto" style={{ maxWidth: '800px' }}>
            User Identification systems transform security and operational management by providing fast, reliable, and accurate verification of individuals. They protect critical resources, improve accountability, and streamline access processes, making them essential for any organization seeking secure, efficient, and modern identity management.
            </p>
            <a href="/contact" className="btn btn-primary btn-lg rounded-pill px-5">Inquire About Partnership</a>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default User;
